import React, { Component } from 'react';
import { Form } from 'react-form';
import Popup from '../../Popup';
import { Input } from '../../Form';
import { required } from '../../../utils/validation';
import { SupportLink } from '../../Links';
import styles from './claimSchoolTeamPopup.scss';

class ClaimSchoolTeamPopup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            submitting: false,
            submitSuccessful: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async handleSubmit(values) {
        this.setState({
            submitting: true,
            submitSuccessful: false,
            updateError: false,
        });

        try {
            await this.props.submitClaimSchoolTeam(values);
            console.log('handleSubmit success');
            this.setState({
                submitting: false,
                submitSuccessful: true,
            });
        } catch (error) {
            console.log('handleSubmit error');
            this.setState({
                submitting: false,
                updateError: true,
            });
        }
    }

    render() {
        const {
            defaultValues,
            onCloseClick,
            onFinishRedirectClick,
        } = this.props;

        return (
            <Popup
                className={`popup-md clear-over-flow`}
                popUpClassName={`${styles.editDualMatchEventPopup}`}
                onCloseClick={onCloseClick}
                config={{
                    noPadding: true,
                    fullScreen: false,
                    topGradient: false,
                    scrollable: false,
                }}
            >
                <div className={`${styles.section} pt0`}>
                    <h4>Claim School Club</h4>
                </div>
                <div className={`${styles.section} pt0`}>
                    <Form onSubmit={values => this.handleSubmit(values)} id="addNewSchoolForm" defaultValues={defaultValues}>
                        {(formApi) => {
                            const { submitForm, errors } = formApi;
                            return (
                                <form onSubmit={submitForm} id="addNewSchool">
                                    {!this.state.submitSuccessful && (
                                        <React.Fragment>
                                            <p className="mb32">You will need to submit a request to gain access to a team that has already been claimed.</p>
                                            <div className="row mb16">
                                                <div className={`col-12 mb24`}>
                                                    <Input
                                                        label="Coach Email"
                                                        id="email"
                                                        field="email"
                                                        // placeholder="Ex. Men's Singles"
                                                        validate={required}
                                                        disableProfanityCheck={true}
                                                    />
                                                    <Input
                                                        label="Comments (Optional)"
                                                        id="comments"
                                                        field="comments"
                                                    />
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {this.state.submitSuccessful && (
                                        <div className="row mb32">
                                            <div className="col-12">
                                                Thanks for submitting your high school request. Our team will contact you within the next 24-48 hours.
                                            </div>
                                        </div>
                                    )}
                                    {(errors || this.state.updateError) && (
                                        <hr />
                                    )}
                                    {errors && (
                                        <div className="pb24 text-center text-error text-small">Email field is required.</div>
                                    )}
                                    {this.state.updateError && (
                                        <div className="pb24 text-center text-error text-small">
                                            An error occurred while submitting this form. If this problem persists, please contact our <SupportLink target="_blank">support team.</SupportLink>
                                        </div>
                                    )}
                                    {this.state.submitSuccessful && (
                                        <div className="row">
                                            <div className="col-12 mb16">
                                                <button
                                                    onClick={onFinishRedirectClick}
                                                    type="button"
                                                    className="btn btn-default btn-xl text-uppercase btn-block"
                                                >
                                                    Got it
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    {!this.state.submitSuccessful && (
                                        <div className="row">
                                            <div className="col-12 col-md-6 mb16">
                                                <button
                                                    onClick={onCloseClick}
                                                    type="button"
                                                    className="btn btn-default btn-xl text-uppercase btn-block"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-xl text-uppercase btn-block"
                                                    disabled={this.state.submitting}
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </form>
                            );
                        }}
                    </Form>
                </div>
            </Popup>
        );
    }
}

export default ClaimSchoolTeamPopup;
